export const ToastType = {
  Success: "Success",
  Info: "Info",
  Warn: "Warn",
  Error: "Error",
};
